import type { SystemStyleFunction } from "@chakra-ui/theme-tools";

const baseStyle: SystemStyleFunction = () => {
    return {
        borderStyle: "solid",
        borderWidth: "1px",
        fontWeight: "bold",
        fontSize: ["mobileBodyB2", "desktopBodyB2"],
        color: "black",
        borderRadius: "full",
        borderColor: "gray.400",
        bg: "white",
        _selected: {
            outline: "none",
        },
        _invalid: {
            bg: "red.50",
            boxShadow: "none",
        },
        _focus: {
            bg: "white",
            zIndex: 1,
            transitionProperty: "none",
            transitionDuration: "0s",
            outlineWidth: ".5px",
            outlineStyle: "solid",
            outlineColor: "black",
            outlineOffset: "0",
            boxShadow: "none",
        },
    };
};

export const textAreaStyles = {
    baseStyle,
};
